import { firestore } from "../../firebase";
import { runTransaction, Transaction } from "firebase/firestore";

class TransactionService {
  static run(callback: (transaction: Transaction) => Promise<any>) {
    if (!callback) return;
    return runTransaction(firestore, callback);
  }
}

export default TransactionService;
